import initHeader from "./layout/header";

            
                                  
         

initHeader();
initResizeBroadcasting();

function initResizeBroadcasting() {
    const url = new URL(window.location.href);
    const instanceId = url.searchParams.get('instanceId');

    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    window.addEventListener('orientationchange', onResize);
    onResize();

    function onResize() {
        window.parent?.postMessage({
            scrollHeight: document.body.scrollHeight,
            scrollWidth: document.body.scrollWidth,
            instanceId,
        }, {
            targetOrigin: "*"
        });
    }
}
